module.exports = __webpack_public_path__ + "img/teams_icon.dbe26b77.png";